import React, { useEffect, useMemo, useState } from "react";
import { Input, Label } from "../../atoms";
import { Apis } from "../../../util/Apis";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const ComboMachine = ({ machineSelected, setMachineSelected }) => {
  const [showList, setShowList] = useState(false);
  // query text para filtrar; inicia con el nombre seleccionado (o cadena vacía)
  const [query, setQuery] = useState(machineSelected?.machineName || "");

  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));
  const { data: machines = [], isLoading } = useQuery({
    queryKey: ["machines", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(
        `${Apis.CAPP}/machines?salaId=${salaInfo.salaId}`
      );
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  const filtered = useMemo(() => {
    if (!query) return machines;
    const q = query.toLowerCase();
    return machines.filter((m) => m.machine.toLowerCase().includes(q));
  }, [machines, query]);

   useEffect(() => {
    setQuery(machineSelected?.machineName || "");
  }, [machineSelected]);

  return (
    <div className="relative flex flex-col w-full">
      <Label>Selecciona una máquina</Label>
      <Input
        type="text"
        placeholder="Ej. 123"
        value={query}
        onFocus={() => setShowList(true)}
        onChange={(e) => {
          const txt = e.target.value;
          setQuery(txt);
          // al tipear, resetear la selección anterior
          setMachineSelected({ confId: null, machineName: txt });
          setShowList(true);
        }}
      />

      {isLoading && (
        <div className="px-2 py-1 text-xs text-slate-400">
          Cargando máquinas...
        </div>
      )}

      {showList && filtered.length > 0 && (
        <div className="absolute z-10 w-full overflow-y-auto bg-white shadow max-h-40 rounded-b-xl top-16">
          {filtered.map((m) => (
            <div
              key={m.confId}
              className="px-4 py-2 cursor-pointer hover:bg-primary/10"
              onClick={() => {
                // Al seleccionar: actualizamos confId y machineName
                setMachineSelected({
                  confId: m.confId,
                  machineName: m.machine,
                });
                setQuery(m.machine);
                setShowList(false);
              }}
            >
              {m.machine}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComboMachine;
